import Splide from '@splidejs/splide';

let quoteSlides = document.getElementsByClassName('quote-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < quoteSlides.length; i++) {
        let splide = new Splide(quoteSlides[i], {
            type: 'fade',
            perPage: 1,
            perMove: 1,
            rewind: true,
            width: '100%',
        });

        splide.mount();
    }
});



